module.exports = __webpack_public_path__ + "img/3.bb8c955e.jpg";